import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between" }

export function render(_ctx, _cache) {
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_form = _resolveComponent("v-form")

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(_ctx.submit, ["prevent"]),
    ref: "form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_text_field, {
        variant: "outlined",
        "validate-on-blur": "",
        label: _ctx.emailData.label,
        placeholder: "Enter email address",
        rules: _ctx.emailData.rules,
        modelValue: _ctx.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.email) = $event)),
        "persistent-placeholder": ""
      }, null, 8, ["label", "rules", "modelValue"]),
      _createVNode(_component_v_text_field, {
        type: "password",
        variant: "outlined",
        "validate-on-blur": "",
        label: _ctx.passwordData.label,
        placeholder: "Your password",
        rules: _ctx.passwordData.rules,
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.password) = $event)),
        "persistent-placeholder": ""
      }, null, 8, ["label", "rules", "modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          type: "submit",
          depressed: "",
          tile: "",
          color: "primary",
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Login ", -1)
          ]))]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_v_btn, {
          text: "",
          onClick: _ctx.resetPassword
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Forgot your password?", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}